import { IConComponents } from '@/modules/adjusterReportModules/IncidentParticipants/assets/iconComponents/iconComponents.type';
import React from 'react';

const Costs: React.FC<IConComponents> = ({
  fill,
  stroke,
  height = '42',
  width = '42',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="20.9961" r="21" fill={fill} />
      <path
        d="M31 14.9883V17.4083C31 18.9883 30 19.9883 28.42 19.9883H25V12.9983C25 11.8883 25.91 10.9883 27.02 10.9883C28.11 10.9983 29.11 11.4383 29.83 12.1583C30.55 12.8883 31 13.8883 31 14.9883Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 15.9883V29.9883C11 30.8183 11.94 31.2883 12.6 30.7883L14.31 29.5083C14.71 29.2083 15.27 29.2483 15.63 29.6083L17.29 31.2783C17.68 31.6683 18.32 31.6683 18.71 31.2783L20.39 29.5983C20.74 29.2483 21.3 29.2083 21.69 29.5083L23.4 30.7883C24.06 31.2783 25 30.8083 25 29.9883V12.9883C25 11.8883 25.9 10.9883 27 10.9883H16H15C12 10.9883 11 12.7783 11 14.9883V15.9883Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 21.998H21"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 17.998H21"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9961 21.9883H15.0051"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9961 17.9883H15.0051"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Costs;
